import pick_list from '../data/pick_list3';
import player_list from '../data/player_list3';

const means = pick_list.map(function (x) {return x.P90});
const values = player_list.map(function (x) {return x.value});

const round_pick_re = /^([0-9]+)\.([0-9]+)$/;
const pick_re = /^([0-9]+)$/;

function sum_array(array) {
  var value = array.reduce((a, b) => a + b, 0);
  if (isNaN(value)) {
    return 0
  }
  else {
    return value
  };
};

function to_ovr(teams=12, pick) {
    if (round_pick_re.test(pick)) {
        var match = round_pick_re.exec(pick);
        var round = +match[1];
        pick = +match[2];
        var ovr = pick + (round - 1)*teams;
        return ovr;
    }
    else {
        return pick;
    };
}

function remove_pick(values, x) {
    var closest = values[0];
    var broken = false;
    var i;
    for (i = 1; i < values.length; i++) {
        if ((Math.abs(closest - x) > Math.abs(values[i] - x)) &&
                (Math.abs(values[i] - x) < Math.abs(values[i+1] - x))) {
            closest = values[i];
            broken = true;
            break;
        }
    }
    if (!broken) {
        i = 0;
    }
    values.splice(i, 1);
    return values;
};

function pick_lookup(avail, best_player, best_pick, pick) {
  return {
    'label': pick,
    'value': avail[pick]*best_player/best_pick
  }
};

function trade(state = [], action) {
  switch(action.type) {
    case 'UPDATE_PICK_SENT' :
      var asOVR = action.value.map((x) => Number(x.value)).map(to_ovr.bind(null, state.leagueSize));
      var updatedPicks = asOVR.map(pick_lookup.bind(
          null, state.picksAvailable, state.bestPlayer, state.bestPick));

        return {
          playerRec: state.playerRec,
          playerSent: state.playerSent,
          pickSent: updatedPicks,
          pickRec: state.pickRec,
          sentValue: sum_array(state.playerSent.map((x) => x.value)) + sum_array(updatedPicks.map((x) => x.value)),
          recValue: state.recValue,
          picksAvailable: state.picksAvailable,
          playersAvailable: state.playersAvailable,
          kept: state.kept,
          bestPick: state.bestPick,
          bestPlayer: state.bestPlayer,
          chopped: state.chopped,
          leagueSize: state.leagueSize
        };
    case 'UPDATE_PICK_REC' :
      var asOVR = action.value.map((x) => Number(x.value)).map(to_ovr.bind(null, state.leagueSize));
      var updatedPicks = asOVR.map(pick_lookup.bind(
          null, state.picksAvailable, state.bestPlayer, state.bestPick));

        return {
          playerRec: state.playerRec,
          playerSent: state.playerSent,
          pickRec: updatedPicks,
          pickSent: state.pickSent,
          recValue: sum_array(state.playerRec.map((x) => x.value)) + sum_array(updatedPicks.map((x) => x.value)),
          sentValue: state.sentValue,
          picksAvailable: state.picksAvailable,
          playersAvailable: state.playersAvailable,
          kept: state.kept,
          bestPick: state.bestPick,
          bestPlayer: state.bestPlayer,
          chopped: state.chopped,
          leagueSize: state.leagueSize
        };
    case 'UPDATE_PICKS_KEPT' :
        // make copy of starting pick list
        var current_pick_list = means.slice();
        action.value.map(remove_pick.bind(null, current_pick_list));

        var current_player_list = values.slice();
        action.value.map(remove_pick.bind(null, current_player_list));

        var updatedPickSent = state.pickSent.map((x) => x.label).map(
          pick_lookup.bind(null, current_pick_list, current_player_list[0],
                           current_pick_list[0]));

        var updatedPickRec = state.pickRec.map((x) => x.label).map(
          pick_lookup.bind(null, current_pick_list, current_player_list[0],
                           current_pick_list[0]));

        return {
          playerRec: state.playerRec,
          playerSent: state.playerSent,
          pickSent: updatedPickSent,
          pickRec: updatedPickRec,
          recValue: sum_array(updatedPickRec.map((x) => x.value)) + sum_array(state.playerRec.map((x) => x.value)),
          sentValue: sum_array(updatedPickSent.map((x) => x.value)) + sum_array(state.playerSent.map((x) => x.value)),
          picksAvailable: current_pick_list,
          playersAvailable: current_player_list,
          kept: action.value,
          bestPick: current_pick_list[0],
          bestPlayer: current_player_list[0],
          chopped: state.chopped,
          leagueSize: state.leagueSize
        }
    case 'UPDATE_PLAYER_SENT' :
      console.log(action.value)
        return {
          playerRec: state.playerRec,
          playerSent: action.value,
          pickSent: state.pickSent,
          pickRec: state.pickRec,
          recValue: state.recValue,
          sentValue: sum_array(action.value.map((x) => Number(x.value))) + sum_array(state.pickSent.map((x) => x.value)),
          picksAvailable: state.picksAvailable,
          playersAvailable: state.playersAvailable,
          kept: state.kept,
          bestPick: state.bestPick,
          bestPlayer: state.bestPlayer,
          chopped: state.chopped,
          leagueSize: state.leagueSize
        };
    case 'UPDATE_PLAYER_REC' :
        return {
          playerRec: action.value,
          playerSent: state.playerSent,
          pickSent: state.pickSent,
          pickRec: state.pickRec,
          sentValue: state.sentValue,
          recValue: sum_array(action.value.map((x) => Number(x.value))) + sum_array(state.pickRec.map((x) => x.value)),
          picksAvailable: state.picksAvailable,
          playersAvailable: state.playersAvailable,
          kept: state.kept,
          bestPick: state.bestPick,
          bestPlayer: state.bestPlayer,
          chopped: state.chopped,
          leagueSize: state.leagueSize
        };
    case 'UPDATE_LEAGUE_SIZE' :
        return {
          playerRec: state.playerRec,
          playerSent: state.playerSent,
          pickSent: state.pickSent,
          pickRec: state.pickRec,
          recValue: state.recValue,
          sentValue: state.sentValue,
          picksAvailable: state.picksAvailable,
          playersAvailable: state.playersAvailable,
          kept: state.kept,
          bestPick: state.bestPick,
          bestPlayer: state.bestPlayer,
          chopped: state.chopped,
          leagueSize: action.value
        };
    default:
        return state;
  }
}

export default trade;





// WEBPACK FOOTER //
// ./src/reducers/trade.js